import { Timezone } from "@syncfusion/ej2-react-schedule";
import { CoachSchedulerAPI } from "../../../api/CoachSchedulerAPI";

export const createSchedule = async (data, createdBy, updatedBy, clubId) => {
    let timezone = new Timezone();
    try {
        const date = new Date(data?.StartTime);

        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);

        const formattedDate = `${year}-${month}-${day}`;
        const reqObject = {
            scheduleId: data.Id,
            scheduleType: data.ScheduleType,
            scheduleDate: formattedDate,
            scheduleStartTime: timezone.removeLocalOffset(data.StartTime).toISOString(),
            scheduleEndTime: timezone.removeLocalOffset(data.EndTime).toISOString(),
            scheduleDescription: data.Description,
            scheduleStatus: "ACTIVE",
            venue: data.Venue,
            homeTeamId: data.HomeTeamId,
            eventId: data.EventId,
            awayOrgId: data.AwayOrgId,
            awayTeamId: data.AwayTeamId,
            recurrenceRule: data.RecurrenceRule ?? null,
            scheduleCreatedBy: createdBy,
            teamIds: data.TeamIds,
            scheduleUpdatedBy: updatedBy,
            clubId: clubId,
            isAwayOrgRegistered: data.IsAwayOrgRegistered,
            awayTeamName: data.AwayTeamName,
            awayOrganizationName: data.AwayOrganizationName,
            resourceId: data.CourtNumber,
            meetingData: data.MeetingData ? JSON.stringify(data.MeetingData) : '{}',
            isRSVP: data.IsRSVP ?? false,
            maxSlot: data.MaxSlot ?? 0,
            isEmailDispatch: data.IsEmailDispatch ?? false,
            isPaid: data.IsPaid,
            subject: data.Subject ?? 'No title',
            isAttachAllMember: data.IsAttachAllMember,
            isUpdateEntireSeries: data.IsUpdateEntireSeries,
            isAttachAllGuest: data.IsAttachGuest
        }
        return await CoachSchedulerAPI.postCreateSchedule(reqObject);
    } catch (error) {
        throw error;
    }
}
export const updateSchedule = async (data, updatedBy, clubId) => {
    let timezone = new Timezone();
    try {
        const reqObject = {
            scheduleId: data.Id,
            scheduleType: data.ScheduleType,
            scheduleStartTime: timezone.removeLocalOffset(data.StartTime).toISOString(),
            scheduleEndTime: timezone.removeLocalOffset(data.EndTime).toISOString(),
            scheduleDescription: data.Description,
            venue: data.Venue,
            homeTeamId: data.HomeTeamId,
            eventId: data.EventId,
            awayOrgId: data.AwayOrgId,
            awayTeamId: data.AwayTeamId,
            recurrenceRule: data.RecurrenceRule,
            teamIds: data.TeamIds,
            scheduleUpdatedBy: updatedBy,
            clubId: clubId,
            recurrenceId: data.RecurrenceID,
            meetingData: data.MeetingData ? JSON.stringify(data.MeetingData) : '{}',
            isRSVP: data.IsRSVP ?? false,
            maxSlot: data.MaxSlot ?? 0,
            subject: data.Subject??'No title',
            isEmailDispatch: data.IsEmailDispatch ?? false,
            resourceId: data.CourtNumber,
            isAttachAllMember: data.IsAttachAllMember,
            isUpdateEntireSeries: data.IsUpdateEntireSeries,
            isAttachAllGuest: data.IsAttachGuest
        }


        await CoachSchedulerAPI.putUpdateSchedule(reqObject);
    } catch (error) {
        console.error(error);
        throw error;
    }
}
export const statusUpdateBody = (data) => ({
    scheduleId: data.id,
    clubId: data.clubId,
    recurrenceId: data.recurrenceId ?? null,
    status: data.status,
    isUpdateEntireSeries: data.isUpdateEntireSeries === true ? "true" : "false",
});

export const updateScheduleStatus = async (data) => {
    try {
        await CoachSchedulerAPI.updateScheduleStatus(statusUpdateBody(data));
    } catch (error) {
        throw error;
    }
}